import { render } from "./ConsultationCallView.vue?vue&type=template&id=981b6c62&scoped=true"
import script from "./ConsultationCallView.vue?vue&type=script&lang=js"
export * from "./ConsultationCallView.vue?vue&type=script&lang=js"

import "./ConsultationCallView.vue?vue&type=style&index=0&id=981b6c62&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981b6c62"]])

export default __exports__